import {h} from 'preact';
import {PageContent, EquipmentItem, EquipmentListHeader, CheckoutButton} from '../components';
import {space} from '../styles';
import {Link} from 'react-router-dom';
import Button from '@components/common/Button';

export const RepairsCart = ( {location, ...props} ) =>
    <PageContent>
        {props.list.length > 0
            ?
            <div>
                <EquipmentListHeader/>
                {props.exclusions.length > 0 &&
                <div className="px-4 md:p-0 mt-2 bg-fail-lightest rounded border-2 border-solid border-fail">
                    <header className={space.th}>
                        <h3 className="text-lg font-normal text-fail">
                            You have some items in your cart that are not eligible for repair
                        </h3>
                        <p className="text-sm">
                            The following items are already associated with an open repair and will be
                            excluded from this repair request.
                        </p>
                    </header>
                    {props.exclusions.map( item =>
                        <EquipmentItem key={item.serialId} {...item}>
                            <div className={`${space.td} text-right`}>
                                <Link class="block text-sm link-2 underline"
                                      to={`/open-repairs/${item.rmaDetail.requestId}`}>
                                    View open repair request
                                </Link>
                                <Button secondary
                                        small
                                        icon="remove"
                                        className="mt-2 error"
                                        onClick={() => props.actions.removeItem( {serialId: item.serialId} )}>
                                    Remove
                                </Button>
                            </div>
                        </EquipmentItem>
                    )}
                    </div>
                }
                {props.list.map( item =>
                    <EquipmentItem key={item.serialId} {...item}>
                        <div className={`${space.td} text-right`}>
                            <Button secondary
                                    small
                                    icon="remove"
                                    className="mt-2"
                                    onClick={() => props.actions.removeItem( {serialId: item.serialId} )}>
                                Remove
                            </Button>
                        </div>
                    </EquipmentItem>
                )}
                <div className="mt-12 flex flex-col md:flex-row mx-auto w-full justify-end">
                    {location.state && location.state.justAdded &&
                    <Link to={'/my-equipment'} className="button secondary">
                        Add another item
                    </Link>
                    }
                    <CheckoutButton count={props.list.length} location={location} className="mt-4 md:mt-0 md:ml-8"/>
                </div>
            </div>
            :
            <div className="text-center mt-8 max-w-sm mx-auto">
                <h2 className="text-lg font-normal px-8">No repair requests yet</h2>
                <p className="mt-1">Go to <Link to={`/my-equipment`}>My Equipment</Link> to add an item to your repair requests list</p>
                <Link to={`/my-equipment`} className="button secondary mt-8">View your equipment</Link>
            </div>
        }
    </PageContent>;